function htmlEscape(str, defintelyContainsHTML) {
  const amperRe_ = /&/g;
  const ltRe_ = /</g;
  const gtRe_ = />/g;
  // eslint-disable-next-line no-useless-escape
  const quotRe_ = /\"/g;
  // eslint-disable-next-line no-useless-escape
  const singleQuotRe_ = /\'/g;
  // eslint-disable-next-line no-useless-escape
  const allRe_ = /[&<>\"\']/;
  if (str === null || str === undefined) {
    return '';
  }
  if (defintelyContainsHTML) {
    return str.replace(amperRe_, '&amp;').replace(ltRe_, '&lt;').replace(gtRe_, '&gt;').replace(quotRe_, '&quot;').replace(singleQuotRe_, '&#x27;');
  } else {
    if (!allRe_.test(str)) {
      return str;
    }
    if (str.indexOf('&') !== -1) {
      str = str.replace(amperRe_, '&amp;');
    }
    if (str.indexOf('<') !== -1) {
      str = str.replace(ltRe_, '&lt;');
    }
    if (str.indexOf('>') !== -1) {
      str = str.replace(gtRe_, '&gt;');
    }
    if (str.indexOf('"') !== -1) {
      str = str.replace(quotRe_, '&quot;');
    }
    if (str.indexOf("'") !== -1) {
      str = str.replace(singleQuotRe_, '&#x27;');
    }
    return str;
  }
}
export default htmlEscape;